const plugin = require('tailwindcss/plugin');

module.exports = {
  // purge: {
  //   enabled: true,
  //   content: ['./src/**/*.js'],
  //   options: {
  //     safelist: [/grid-/, /float-/, /rc-slider/]
  //   }
  // },
  important: true,
  variants: {
    extend: {
      borderWidth: ['odd', 'even'],
      padding: ['first', 'last', 'odd', 'even'],
      backgroundColor: ['odd', 'even', 'hover', 'disabled'],
      opacity: ['disabled'],
      position: ['hover'],
      width: ['responsive', 'hover', 'focus', 'group-hover'],
      height: ['responsive', 'hover', 'focus'],
      borderRadius: ['responsive', 'hover', 'focus']
    }
  },

  theme: {
    fontFamily: {
      primary: ['AudiLatin', 'sans-serif'], // Normal Audi font
      secondary: ['Audi', 'sans-serif'] // Audi Extended font (named Audi in order not to break font used in LMA's)
    },
    screens: {
      sm: '600px',
      sm2: '962px',
      md: '1200px',
      md2: '1400px',
      md3: '1600px',
      lg: '1792px',
      xl: '1992px'
    },

    fontWeight: {
      regular: 400,
      normal: 500,
      semibold: 600,
      bold: 700
    },

    extend: {
      colors: {
        primary: {
          light: '#f65678',
          DEFAULT: '#BC0A30',
          dark: '#a9092b'
        },

        secondary: {
          light: '#F2F2F2',
          DEFAULT: '#666666',
          dark: '#333333'
        },

        error: {
          light: '#FFF8F6',
          DEFAULT: '#dc3545'
        },

        warning: {
          DEFAULT: '#ffc107'
        },

        success: {
          DEFAULT: '#28a745'
        },

        common: {
          'content-background': {
            light: '#f2f2f2',
            DEFAULT: '#666666',
            dark: '#333333'
          },
          'content-text': {
            light: '#808080',
            DEFAULT: '#666666',
            dark: '#333333'
          }
        }
      },

      borderRadius: {
        sm: '0px',
        DEFAULT: '0px',
        lg: '0px'
      },

      lineHeight: {
        18: '18px',
        20: '20px',
        21: '21px',
        22: '22px',
        23: '23px',
        24: '24px',
        25: '25px',
        26: '26px',
        28: '28px',
        31: '31px',
        32: '32px',
        33: '33px',
        40: '40px',
        46: '46px',
        48: '48px',
        54: '54px',
        56: '56px',
        60: '60px',
        63: '63px'
      },

      zIndex: {
        '-1': -1,
        1: 1,
        2: 2,
        60: 60,
        70: 70,
        80: 80,
        90: 90,
        100: 100
      },

      spacing: {
        '2px': '2px',
        1.25: '0.313rem',
        4.5: '1.125rem',
        5.5: '1.375rem',
        9.5: '2.375rem',
        13: '3.25rem',
        15.5: '3.875rem',
        17: '4.25rem',
        18: '4.5rem',
        19: '4.75rem',
        22: '5.5rem',
        23.5: '5.875rem',
        25: '6.25rem',
        26: '6.5rem',
        30: '7.5rem',
        34: '8.5rem',
        35: '8.75rem',
        38: '9.5rem',
        39: '9.75rem',
        46: '11.5rem',
        50: '12.5rem',
        54: '13.5rem',
        59: '14.75rem',
        62: '15.5rem',
        74: '18.5rem',
        75: '18.75rem',
        104: '26rem',
        112: '28rem',
        120: '30rem',
        122: '31rem',
        124: '32rem',
        128: '34rem',
        150: '37.5rem',
        152: '38rem',
        160: '40rem',
        168: '42rem',
        172: '43rem',
        174: '43.5rem',
        175: '43.75rem',
        200: '50rem',
        '100px': '100px',
        '190px': '190px',
        '200px': '200px',
        '210px': '210px',
        '220px': '220px',
        '344px': '344px',
        '380px': '380px',
        '494px': '494px',
        '600px': '600px',
        '700px': '700px',
        '824px': '824px',
        '900px': '900px',
        '1172px': '1172px',
        '1360px': '1360px'
      },

      minWidth: (theme) => theme('spacing'),
      maxWidth: (theme) => theme('spacing'),
      minHeight: (theme) => theme('spacing'),
      maxHeight: (theme) => theme('spacing'),

      fontSize: {
        9: '9px',
        10: '10px',
        11: '11px',
        12: '12px',
        13: '13px',
        14: '14px',
        15: '15px',
        16: '16px',
        17: '17px',
        18: '18px',
        19: '19px',
        20: '20px',
        21: '21px',
        22: '22px',
        23: '23px',
        24: '24px',
        26: '26px',
        27: '27px',
        28: '28px',
        29: '29px',
        30: '30px',
        32: '32px',
        33: '33px',
        35: '35px',
        36: '36px',
        39: '39px',
        40: '40px',
        45: '45px',
        48: '48px',
        52: '52px'
      }
    }
  },

  plugins: [
    plugin(function ({ addBase, config, theme }) {
      addBase(theme);
    })
  ]
};
